<template>
  <cTable :fields="fields" :footer="footer" :config="config" ref="table">
  </cTable>
</template>
<script>
import numFun from "@/utils/numFun";
import cTable from "@/base/common/index";

export default {
  props: {
    row: Array,
  },
  components: {
    cTable,
  },
  mounted() {
    this.$refs.table.list = this.row;
  },
  data() {
    return {
      config: {
        resize: false,
        slot: "div",
        height: "200",
        showFooter: true,
        footerCellClassName: "col-red",
      },
      footer: {
        show: () => false,
      },
      fields: [
        {
          name: () => this.$t("classExpense"),
          key: "expense_item",
          minWidth: 130,
        },
				{
				  name: () => this.$t("currencyCode"),
				  key: "currency",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("reChAmount"),
				  key: "amount",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("Remarks"),
				  key: "remarks",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("createUser"),
				  key: "create_name",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("createTime"),
				  key: "create_time",
				  minWidth: 130,
				},
      ],
    };
  },
};
</script>
